<template>
  <div class="double-col-block row-1 p-top-9 p-bot-7">
    <div class="news-column">
      <div class="news-column__intro">
        <h2 class="title-medium3" v-html="$t('common.news')" />
        <NuxtLink :to="localePath({ name: 'news-archivio' })">
          <div class="text-medium5 default-icon-btn is-medium-bold">
            <span v-html="$t('common.vediNews')" />
            <ArrowIcon alt="Arrow icon" class="icon-arrow" />
          </div>
        </NuxtLink>
      </div>
      <div class="news-column__grid">
        <div
          class="news-column__grid__item show-for-large"
          v-for="(news, index) in newsHighlight"
          :key="index"
        >
          <NuxtLink
            :to="
              localePath({
                name: 'news-slug',
                params: { slug: news.slug },
              })
            "
          >
            <div class="news-column__grid__item__image">
              <div
                v-if="
                  news.sezioneContenutoPagina?.length &&
                  news.sezioneContenutoPagina[0].custom?.length
                "
              >
                <WidgetPicture
                  :image="{
                    custom: news.sezioneContenutoPagina[0].custom[0],
                  }"
                  :alt="news.sezioneContenutoPagina[0].custom[0]?.title"
                />
              </div>
            </div>
            <div
              v-if="news.title"
              class="news-column__grid__item__title text-medium5"
            >
              <p v-html="news.title" />
            </div>
          </NuxtLink>
        </div>
        <div class="hide-for-large">
          <PagesNewsImageTextLinkSwiper :item="newsHighlight" />
        </div>
      </div>
    </div>
    <div class="videos-column">
      <div class="videos-column__intro">
        <h2 class="title-medium3" v-html="$t('common.videos')" />
        <a href="https://www.youtube.com/@bioenologia2.0srl86" target="_blank">
          <div class="text-medium5 default-icon-btn is-medium-bold">
            <span v-html="$t('common.vediVideo')" />
            <ArrowIcon alt="Arrow icon" class="icon-arrow" />
          </div>
        </a>
      </div>
      <div class="video-list">
        <div
          class="video-list__item show-for-large"
          v-for="(video, index) in videos"
          :key="index"
        >
          <a :href="video.linkDefault" target="_blank">
            <div class="video-list__item__image">
              <div v-if="video.portrait?.length">
                <WidgetPicture
                  :image="{
                    custom: video.portrait?.[0],
                  }"
                  :alt="video.portrait?.[0]?.title"
                />
                <div class="play-icon">
                  <PlayIcon :filled="true" />
                </div>
              </div>
            </div>
            <div
              v-if="video.title"
              class="video-list__item__title text-medium5"
            >
              <p v-html="video.title" />
            </div>
          </a>
        </div>
        <div class="hide-for-large">
          <PagesNewsImageTextLinkSwiper :item="videos" type="video" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'
import PlayIcon from '@/assets/img/ico/play.svg'

const props = defineProps({
  newsHighlight: {
    type: Array,
    default: () => [],
  },
  videos: {
    type: Array,
    default: () => [],
  },
})
</script>

<script>
export default {
  name: 'DoubleColBlock',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
